export default __webpack_public_path__ + "static/media/logout.d2fac209.png";